import { useState, useCallback } from "react";

/**
 * Custom Hook that provides partial state updates to setState
 * @param initialState - The initial state
 * @returns [state, updateState] - The state and the update function
 */

export function usePartialState<T>(
  initialState: T,
): [T, (updates: Partial<T>) => void] {
  const [state, setState] = useState(initialState);

  const updateState = useCallback((updates: Partial<T>) => {
    setState((prev) => ({
      ...prev,
      ...updates,
    }));
  }, []);

  return [state, updateState];
}
